import { IAuthOptions } from '@prz-dp/services';
import { IKitThemes } from '@prz-dp/ui';

const { BUILD_MODE } = process.env;
const { BUILD_REALM } = process.env;
const { PROJECT_URL } = process.env;
const { MQTT_PASSWORD } = process.env;
const { MQTT_USERNAME } = process.env;
const isMode = (mode: string): boolean => BUILD_MODE === mode;
const isRealm = (mode: string): boolean => BUILD_REALM === mode;

console.info(`Build mode :: ${BUILD_MODE}`);
console.info(`Build realm :: ${BUILD_REALM}`);

const clientId = 'partnership';
const unauthorizedRouteName = 'Unauthorized';
const port = 9093;
const realm = BUILD_REALM || 'prozis';
const privateBaseUrl = '/api/(.*?/)?private';
const assistantGraphqlUrl = '/api/assistant/private/graphql';
const chatGraphqlUrl = '/api/chat/private/graphql';
const chatRestUrl = '/api/chat/private/rest';
const socialNetworkUrl = '/api/social-network/private/graphql';
const socialNetworkClubUrl = '/api/club/private/graphql';
const socialNetworkCropUrl = '/api/interplay/private';
const socialNetworkMediaUrl = '/api/social-network/media/private';
const baseGraphqlUrl = '/api/base/private/graphql';
const baseRestUrl = '/api/base/private/rest';
const uploadUrl = '/api/upload';
const onDemandCampaignsUrl = '/api/campaign/private/graphql';
const liveUrl = '/api/live/private/graphql';
const refreshUri = '/api/auth/refresh';
const refreshDirectlyWithKeycloak = true;

const partnershipAppUserEmail = 'partnership.app@prozis.com';

let domain = '';

let clientLogUri = '/api/client-log';

let defaultPage = '/apps/dashboard';

let auth: IAuthOptions;

let mqtt = {
  password: MQTT_PASSWORD,
  url: `wss://${PROJECT_URL}/mqtt`,
  username: MQTT_USERNAME
};

if (isMode('local')) {
  domain = 'localhost';

  clientLogUri = '';

  defaultPage = '/app/chat';

  auth = {
    clientId,
    privateBaseUrl,
    realm,
    redirectUri: `http://localhost:${port}`,
    unauthorizedRouteName,
    url: 'https://auth.qa.prozis.tech/auth'
  };

  mqtt = {
    password: 'app_connect_users',
    url: 'wss://partnership-prozis-ui.dev.prozis.tech/mqtt',
    username: 'app_connect_users'
  };
}

if (isMode('dev') && isRealm('prozis')) {
  domain = '.prozis.tech';

  auth = {
    clientId,
    privateBaseUrl,
    realm,
    redirectUri: 'https://partnership-prozis-ui.dev.prozis.tech',
    unauthorizedRouteName,
    url: 'https://auth.qa.prozis.tech/auth'
  };
}

if ((isMode('prd') || isMode('production')) && isRealm('prozis')) {
  domain = '.prozis.com';

  auth = {
    clientId,
    privateBaseUrl,
    realm,
    redirectUri: 'https://partnership.prozis.com',
    unauthorizedRouteName,
    url: 'https://auth.prozis.tech/auth'
  };
}

export const prozisAppAppleStoreURL =
  'https://apps.apple.com/app/prozis-store/id1398365437' as const;

export const prozisAppGoogleStoreURL =
  'https://play.google.com/store/apps/details?id=com.prozis.store&launch=true' as const;

export default {
  assistantGraphqlUrl,
  auth,
  baseGraphqlUrl,
  baseRestUrl,
  baseUrl: auth.redirectUri,
  chatGraphqlUrl,
  chatRestUrl,
  clientLogUri,
  defaultLanguage: {
    code: 'pt-PT',
    name: 'Portugues'
  },
  defaultPage,
  domain,
  hsl404Color: 300,
  liveUrl,
  mqtt,
  msg404: '404 Dude, I think you are lost',
  onDemandCampaignsUrl,
  partnershipAppUserEmail,
  refreshDirectlyWithKeycloak,
  refreshUri,
  socialNetworkClubUrl,
  socialNetworkCropUrl,
  socialNetworkMediaUrl,
  socialNetworkUrl,
  theme: IKitThemes.BASE,
  uploadUrl
};
